import { useState, useEffect, useCallback, useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumb from '../../components/Breadcrumbs.component';
import Pagination from '../../components/Pagination.component';
import { useStyles } from '../styles';
import Layout from '../../components/Layout/Layout.component';
import { useHistory } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { Paths } from '../../utils/routerUrls';
import { ActionMenuItem } from '../../components/ActionsMenu/ActionsMenu.types';
import ActionsMenu from '../../components/ActionsMenu/ActionsMenu.component';
import _ from 'lodash';
import { ItemsFilter } from '../../components/SelectableTable/filters/ItemsFilter.component';
import { SelectableTable } from '../../components/SelectableTable/SelectableTable.component';
import { SessionListItem, SessionSortBy, SessionsTableItem } from '../../models/sessionListItem.types';
import {
  deleteClosedSession,
  deleteSession,
  exportResultsToSioepkz,
} from '../../services/exams/sessions/sessions.service';
import SessionCreate from '../Session/SessionCreate/SessionCreate.component';
import usePermission, { UserPermission } from '../../hooks/usePermission';
import SessionDetailsModal from '../../components/EditSession/SessionDetailsModal/SessionDetailsModal.component';
import { SessionsParametersDialog } from './SessionsParametersDialog/SessionsParametersDialog.component';
import { SessionsImagesDialog } from './SessionsImages/SessionImagesDialog';
import { ImportExamineeListApi } from './ImportExamineeListApi/ImportExamineeListApi.component';
import { LeavePrompt } from '../../components/Prompt/LeavePrompt/LeavePrompt.component';
import { useLayoutContext } from '../../Context/Layout.context';
import { getImportApiExamineeCount } from '../../services/images/images.service';
import { Prompt } from '../../components/Prompt/Prompt.component';
import { useTranslation } from 'react-i18next';
import { hasOnePermissionToAccess } from '../../services/users/identity/user.service';
import useSessionUser from '../../hooks/useSessionUser';
import { AdjustmentsModal } from '../../components/Adjustments/AdjustmentsModal.component';
import { FinancialReport } from '../../components/FinancialReport/FinancialReport.component';
import { ExamResultsRepository } from '../../components/ExamResultsRepository/ExamResultsRepository.component';
import { ExamRepositoryModalType } from '../../components/ExamResultsRepository/ExamResultsRepository.types';
import EnvWindow from '../../utils/env';
import { IDeleteClosed } from '../../models/session.types';
import { formatDate } from '../Assessment/Helpers/FormatDate.component';
import { TaskAltOutlined } from '@mui/icons-material';
import { InfoOutlined } from '@mui/icons-material';
import { DateFilter } from '../../components/SelectableTable/filters/DateFilter.component';
import { SessionsCopyDialog } from './SessionsCopyDialog/SessionsCopyDialog.component';
import { useSessionsTableData } from './useSessionsTableData';
import { useSessionsTableColumns } from './useSessionsTableColumns';
import { ExaminerTreemapModal } from '../ExaminerTreemap/ExaminerTreemapModal.component';
import { DataForExaminerTreeMap } from '../Dashboard/Dashboard.types';
import TooltipOne from '../../components/TooltipOne/TooltipOne.component';

const Sessions: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const { user } = useSessionUser();
  const { showLoader, openAlert, isSidebarMinimized } = useLayoutContext();

  const {
    sessionId,
    filter,
    pageInfo,
    sessions,
    selectedSessionId,
    setSelectedSessionId,
    selectedSoureSystem,
    setSelectedSourceSystem,
    selectedSheetCode,
    setSelectedSheetCode,
    selectedSheetId,
    setSelectedSheetId,
    selectedSystem,
    setSelectedSystem,
    getSessions,
    handleFilterChange,
    getPages,
    uncheckFilterItem,
    uncheckAllFilters,
    sortByColumnId,
    setSortByColumnId,
    isDescending,
    setIsDescending,
    filterState,
  } = useSessionsTableData();

  const [sessionsData, setSessionsData] = useState<SessionsTableItem[]>([]);

  const [isImportFromFile, setIsImportFromFile] = useState<boolean>(false);
  const [isCreated, setIsCreated] = useState<boolean>(false);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalSheetId, setModalSheetId] = useState<string>('');
  const [modalIsSheetConfigured, setModalIsSheetConfigured] = useState<boolean>(false);
  const [modalIsSheetImported, setModalIsSheetImported] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [isLeavePromptOpen, setIsLeavePromptOpen] = useState<boolean>(false);
  const [isModalImageOpen, setIsModalImageOpen] = useState<boolean>(false);
  const [isImportExamineeModalApi, setIsImportExamineeModalApi] = useState<boolean>(false);
  const [isAdjustmentsModalOpen, setIsAdjustmentsModalOpen] = useState<boolean>(false);
  const [activeSheetSymbol, setActiveSheetSymbol] = useState<string>('');
  const [examineeCount, setExamineeCount] = useState<string>('0');
  const [isConfirmationPromptVisible, setIsConfirmationPromptVisible] = useState<boolean>(false);
  const [isDeletePromptVisible, setIsDeletePromptVisible] = useState<boolean>(false);
  const [isErrorPromptVisible, setIsErrorPromptVisible] = useState<boolean>(false);
  const [isSuccessPromptVisible, setIsSuccessPromptVisible] = useState<boolean>(false);
  const [isResultsExportConfirmationPromptVisible, setIsResultsExportConfirmationPromptVisible] =
    useState<boolean>(false);
  const [modalActiveTab, setModalActiveTab] = useState<string>('');
  const [isFinancialReportOpen, setIsFinancialReportOpen] = useState<boolean>(false);
  const [isExamResultsRepositoryOpen, setIsExamResultsRepositoryOpen] = useState<boolean>(false);
  const [examRepositoryModalType, setExamRepositoryModalType] = useState<ExamRepositoryModalType>(
    ExamRepositoryModalType.results,
  );
  const [selectedSession, setSelectedSession] = useState<DataForExaminerTreeMap>();
  const [examinerTreemapModalOpen, setExaminerTreemapModalOpen] = useState<boolean>(false);
  const [selectedExamSheetId, setSelectedExamSheetId] = useState<string>('');
  const [isSessionCopyDialogOpen, setIsSessionCopyDialogOpen] = useState<boolean>(false);

  const { columns } = useSessionsTableColumns();

  const hasAdminSessionStatusManagePermission = usePermission(UserPermission.AdminSessionStatusManage);
  const hasAdminOkeExamineeImport = usePermission(UserPermission.AdminOkeExamineeImport);
  const hasAdminExaminerLineupsRead =
    usePermission(UserPermission.AdminOkeExaminersLineupsRead) ||
    usePermission(UserPermission.AdminExaminersLineupsRead);
  const hasPermissionsTosetLimits = hasOnePermissionToAccess(user, [
    UserPermission.AdminSessionStatusManage,
    UserPermission.AdminSessionScheduleManage,
    UserPermission.AdminSessionParamsManage,
  ]);
  const hasAdminSessionResultsToSioepkzExportPermission = usePermission(UserPermission.AdminOkeResultsExport);
  const hasAdminResultsAccessPermission = usePermission(UserPermission.AdminResultsAccess);
  const hasAdminOkeResultsAccessPermission = usePermission(UserPermission.AdminOkeResultsAccess);
  const hasAdminSessionParamsManagePersmission = usePermission(UserPermission.AdminSessionParamsManage);

  const handleSessionCreation = () => {
    setIsCreated(true);
  };

  useEffect(() => {
    if (isCreated) {
      getSessions();
      setIsCreated(false);
    }
  }, [isCreated]);

  const updateActiveSessionSymbols = (session: SessionListItem | undefined) => {
    setModalSheetId(session ? session.sheetId : '');
    setModalIsSheetConfigured(session ? session.isConfigured : false);
    setModalIsSheetImported(session ? session.sourceSystemName !== t('global:shortNames.system') : false);
    setActiveSheetSymbol(session ? `${session.subjectCode}${session.sheetCode ? '-' + session.sheetCode : ''}` : '');
    setModalTitle(session ? `${session?.subject} (${session?.sheetCode})` : '');
  };

  const handleOpenModal = useCallback(
    (id?: string, sheetId?: string) => {
      setIsModalOpen(true);
      if (id && sheetId) {
        const session = sessions.find((s: SessionListItem) => s.id === id && s.sheetId === sheetId);
        updateActiveSessionSymbols(session);
      }
    },
    [sessions],
  );

  const handleOpenImageModal = useCallback(
    (id?: string, sheetId?: string) => {
      setIsModalImageOpen(true);
      if (id && sheetId) {
        const session = sessions.find((s: SessionListItem) => s.id === id && s.sheetId === sheetId);
        updateActiveSessionSymbols(session);
      }
    },
    [sessions],
  );

  const handleOpenImportExamineeModalApi = useCallback(
    (id?: string, sheetId?: string) => {
      if (id && sheetId) {
        const session = sessions.find((s: SessionListItem) => s.id === id && s.sheetId === sheetId);
        updateActiveSessionSymbols(session);
        showLoader(true);
        getImportApiExamineeCount(sheetId)
          .then((res: AxiosResponse) => {
            setExamineeCount(res.data);
            setIsImportExamineeModalApi(true);
          })
          .catch(() => {
            setIsImportExamineeModalApi(true);
            setExamineeCount('');
          })
          .finally(() => showLoader(false));
      }
    },
    [sessions],
  );

  const handleOpenAdjustmentsModal = (session: SessionListItem) => {
    updateActiveSessionSymbols(session);
    setIsAdjustmentsModalOpen(true);
  };

  const onSessionActionsClick = useCallback(
    (id: string) => {
      if (hasAdminSessionStatusManagePermission) {
        history.push(`${Paths.sessions}/${id}`);
      }
    },
    [hasAdminSessionStatusManagePermission, history],
  );

  const getActionsMenuIcon = (data: SessionListItem, rowIndex: number): JSX.Element => {
    const items: ActionMenuItem[] = [];
    if (hasAdminSessionStatusManagePermission) {
      items.push({
        text: 'Szczegóły',
        onClick: () => {
          onSessionActionsClick(data.id);
        },
      });
    }
    if (hasAdminExaminerLineupsRead && data.sheetId) {
      items.push({
        text: 'Zarządzaj strukturą egzaminatorów',
        onClick: () => {
          setSelectedSession({
            sheetId: data.sheetId,
            assessmentSessionName: data.sessionName,
            sheetCode: data.sheetCode,
            subject: data.subject,
            isExamSheetConfigured: data.isConfigured ? 'true' : 'false',
          });
          setExaminerTreemapModalOpen(true);
        },
      });
    }
    if (hasPermissionsTosetLimits && data.sheetId) {
      items.push(
        {
          text: 'Ustaw parametry sesji oceniania',
          onClick: () => {
            setModalActiveTab('Zdefiniuj limity kart i dostęp');
            handleOpenModal(data.id, data.sheetId);
          },
        },
        {
          text: 'Zarządzaj strefą obrazu',
          onClick: () => {
            handleOpenImageModal(data.id, data.sheetId);
          },
        },
      );
    }
    if (
      hasAdminOkeExamineeImport &&
      data.sheetId &&
      data.sourceSystemName !== t('global:shortNames.system') &&
      data.isConfigured
    ) {
      items.push({
        text: 'Import zdających API',
        onClick: () => {
          setIsImportFromFile(false);
          setSelectedSystem(data.sourceSystemName);
          handleOpenImportExamineeModalApi(data.id, data.sheetId);
        },
      });
    }
    if (hasAdminOkeExamineeImport && data.sheetId && data.isConfigured) {
      items.push({
        text: 'Import zdających z pliku',
        onClick: () => {
          setIsImportFromFile(true);
          setSelectedSystem(data.sourceSystemName);
          handleOpenImportExamineeModalApi(data.id, data.sheetId);
        },
      });
    }
    if (hasAdminSessionStatusManagePermission)
      items.push({
        text: 'Dostosowania',
        onClick: () => {
          setSelectedSystem(data.sourceSystemName);
          handleOpenAdjustmentsModal(data);
        },
      });
    if (hasAdminSessionStatusManagePermission && !data.hasNonClosedAssessmentSessions && data.isConfigured)
      items.push({
        text: 'Rozliczenia finansowe',
        onClick: () => {
          setSelectedSessionId(data.sheetId);
          setSelectedSheetCode(data.sheetCode);
          setIsFinancialReportOpen(true);
        },
      });
    if (hasAdminSessionResultsToSioepkzExportPermission && data.sourceSystemName === 'SIOEPKZ')
      items.push({
        text: 'Prześlij wyniki do SIOEPKZ',
        onClick: () => {
          setSelectedSessionId(data.sheetId);
          setIsResultsExportConfirmationPromptVisible(true);
        },
      });
    if (hasAdminResultsAccessPermission && !data.hasNonClosedAssessmentSessions)
      items.push({
        text: 'Pobierz wyniki',
        onClick: () => {
          setExamRepositoryModalType(ExamRepositoryModalType.results);
          setSelectedSheetId(data.sheetId);
          setSelectedSheetCode(data.sheetCode);
          setIsExamResultsRepositoryOpen(true);
        },
      });
    if (hasAdminOkeResultsAccessPermission && !data.hasNonClosedAssessmentSessions)
      items.push({
        text: 'Dokumentacja',
        onClick: () => {
          setExamRepositoryModalType(ExamRepositoryModalType.documentation);
          setSelectedSourceSystem(data.sourceSystemType);
          setSelectedSheetCode(data.sheetCode);
          setSelectedSheetId(data.sheetId);
          setIsExamResultsRepositoryOpen(true);
        },
      });
    if (
      hasAdminSessionStatusManagePermission &&
      !data.hasNonClosedAssessmentSessions &&
      !data.hasClosedAssessmentSessionsInGracePeriod
    )
      items.push({
        text: 'Usuń arkusz egzaminacyjny',
        onClick: () => {
          setSelectedSheetCode(data.sheetCode);
          setSelectedSheetId(data.sheetId);
          setIsDeletePromptVisible(true);
        },
      });
    if (hasAdminSessionParamsManagePersmission && data.sheetCode && data.sheetId)
      items.push({
        text: 'Kopiuj arkusz',
        onClick: () => {
          setSelectedExamSheetId(data.sheetId);
          setIsSessionCopyDialogOpen(true);
        },
      });

    if (EnvWindow.REACT_APP_DXC_ENV) {
      items.push({
        text: 'Usuń arkusz egzaminacyjny bez warunków',
        onClick: () => {
          setSelectedSheetCode(data.sheetCode);
          setSelectedSheetId(data.sheetId);
          setIsDeletePromptVisible(true);
        },
      });
    }

    return <ActionsMenu menuItems={items} rowIndex={rowIndex} />;
  };

  const getStateTableItem = (state: boolean) => {
    switch (state) {
      case true:
        return (
          <TooltipOne title="Nie wszystkie sesje zamknięte" placement="top">
            <InfoOutlined style={{ position: 'relative', color: '#FF9E0D', width: '20px', left: '5px', top: '2px' }} />
          </TooltipOne>
        );
      case false:
        return (
          <TooltipOne title="Wszystkie sesje zamknięte" placement="top">
            <TaskAltOutlined
              style={{ position: 'relative', color: '#347F42', width: '19px', left: '5px', top: '3px' }}
            />
          </TooltipOne>
        );
    }
  };

  useEffect(() => {
    const sessionsTableData: SessionsTableItem[] = sessions.map((data: SessionListItem, index) => ({
      sessionName: data.sessionName,
      tableEnterId: data.id,
      examType: data.examType,
      subject: data.subject,
      isConfigured: data.isConfigured ? 'TAK' : 'NIE',
      sheetCode: data.sheetCode,
      year: data.year,
      month: data.monthName,
      sourceSystemType: data.sourceSystemType,
      sourceSystemName: data.sourceSystemName,
      archive: data.archiveAfter ? formatDate(new Date(data.archiveAfter), false) : <></>,
      state: getStateTableItem(data.hasNonClosedAssessmentSessions),
      actions: getActionsMenuIcon(data, index),
      hasNonClosedAssessmentSessions: data.hasNonClosedAssessmentSessions,
    }));
    setSessionsData(sessionsTableData);
  }, [sessions]);

  const getStateMenuItems = () => {
    const stateMenuItems = [
      {
        value: '2',
        text: 'Wszystkie sesje zamknięte',
        jsxElement: (
          <div>
            <TaskAltOutlined style={{ position: 'relative', color: '#347F42', width: '20px', top: '3px' }} />
          </div>
        ),
      },
      {
        value: '1',
        text: 'Nie wszystkie sesje zamknięte',
        jsxElement: (
          <div>
            <InfoOutlined style={{ position: 'relative', color: '#FF9E0D', width: '20px', top: '2px' }} />
          </div>
        ),
      },
    ];
    return stateMenuItems;
  };

  const filterElements: { [key: string]: JSX.Element } = useMemo(
    () => ({
      sourceSystemName: (
        <ItemsFilter
          valueName="sourceSystemType"
          valueLabel="System źródłowy"
          onChange={handleFilterChange}
          resetFilter={!filter.sourceSystemType.length}
          itemsWithValues={[
            { label: 'SIOEO', value: '1' },
            { label: 'SIOEPKZ', value: '2' },
            { label: t('global:shortNames.system'), value: '3' },
          ]}
          filter={filter.sourceSystemType}
        />
      ),
      isConfigured: (
        <ItemsFilter
          valueName="isConfigured"
          valueLabel="Konfiguracja arkusza"
          onChange={handleFilterChange}
          resetFilter={!filter.isConfigured.length}
          itemsWithValues={[
            { label: 'TAK', value: '1' },
            { label: 'NIE', value: '2' },
          ]}
          filter={filter.isConfigured}
        />
      ),
      month: (
        <ItemsFilter
          valueName="month"
          valueLabel="Miesiąc"
          onChange={handleFilterChange}
          resetFilter={!filter.month.length}
          itemsWithValues={[
            { label: 'Styczeń', value: '1' },
            { label: 'Luty', value: '2' },
            { label: 'Marzec', value: '3' },
            { label: 'Kwiecień', value: '4' },
            { label: 'Maj', value: '5' },
            { label: 'Czerwiec', value: '6' },
            { label: 'Lipiec', value: '7' },
            { label: 'Siepień', value: '8' },
            { label: 'Wrzesień', value: '9' },
            { label: 'Październik', value: '10' },
            { label: 'Listopad', value: '11' },
            { label: 'Grudzień', value: '12' },
          ]}
          filter={filter.month}
        />
      ),
      archive: (
        <DateFilter
          fromValueName="archiveFrom"
          toValueName="archiveTo"
          onChange={handleFilterChange}
          resetFilter={!filter.archiveFrom.length && !filter.archiveTo.length}
          isActiveFilter={filter.archiveFrom.length > 0 || filter.archiveTo.length > 0}
          isTimePicker={false}
          valueFrom={filter.archiveFrom as string}
          valueTo={filter.archiveTo as string}
        />
      ),
      state: (
        <ItemsFilter
          valueName="state"
          valueLabel="Stan"
          onChange={handleFilterChange}
          resetFilter={filter.state === ''}
          itemsWithImages={getStateMenuItems()}
          filter={filter.state}
          transformHorizontal={250}
        />
      ),
    }),
    [filter, handleFilterChange, t],
  );

  const closeModal = () => {
    setIsLeavePromptOpen(false);
    setIsModalImageOpen(false);
    setIsAdjustmentsModalOpen(false);
    setIsModalOpen(false);
    updateActiveSessionSymbols(undefined);
  };

  const handleXClose = (isDataChanged: boolean) => {
    if (isDataChanged) {
      setIsLeavePromptOpen(true);
    } else {
      closeModal();
    }
  };

  const deleteExaminigSession = () => {
    if (selectedSessionId) {
      deleteSession(selectedSessionId).then(
        () => {
          setIsConfirmationPromptVisible(false);
          setIsErrorPromptVisible(false);
          setIsSuccessPromptVisible(true);
          getSessions();
        },
        () => {
          setIsConfirmationPromptVisible(false);
          setIsErrorPromptVisible(true);
        },
      );
    }
  };

  const deleteClosed = () => {
    showLoader(true, 'Usuwam dane');
    if (selectedSheetId) {
      deleteClosedSession(selectedSheetId)
        .then(
          (response) => {
            if (response.data === IDeleteClosed.Success) {
              setIsDeletePromptVisible(false);
              openAlert('success', 'Przyjęto zlecenie usunięcia arkusza.');
              getSessions();
            } else {
              setIsDeletePromptVisible(false);
              openAlert('error', 'Wystąpił błąd podczas przyjmowania zlecenia usunięcia arkusza. Spróbuj ponownie.');
            }
          },
          () => {
            setIsDeletePromptVisible(false);
            openAlert('error', 'Wystąpił błąd podczas przyjmowania zlecenia usunięcia arkusza. Spróbuj ponownie.');
          },
        )
        .finally(() => {
          showLoader(false);
        });
    }
  };

  const handleExportResults = () => {
    if (selectedSessionId) {
      showLoader(true, 'Eksportuję wyniki');
      exportResultsToSioepkz(selectedSessionId)
        .then(
          () => {
            openAlert('success', 'Zlecenie eksportu wyników do SIOEPKZ zostało pomyślnie przyjęte');
          },
          () => {
            openAlert('error', 'Zlecenie eksportu wyników do SIOEPKZ nie powiodło się');
          },
        )
        .finally(() => {
          showLoader(false);
        });
    }
  };

  const exportExaminigSessionResults = () => {
    setIsResultsExportConfirmationPromptVisible(false);
    handleExportResults();
  };

  return (
    <Layout viewType={'admin'}>
      <div className={classes.tableAndBreadcrumContainer}>
        <div className={classes.adminBreadcrumbHeader}>
          <Breadcrumb listRoute={Paths.sessions} currentList={t('global:sidebar.sessions')} />
          <div className={classes.adminButtonsContainer}>
            {usePermission(UserPermission.AdminSessionCreate) && <SessionCreate onCreation={handleSessionCreation} />}
          </div>
        </div>
        <div className={classes.tableWhiteCardFlex}>
          <div className={classes.filtersContainerFlex}>
            <div className={classes.usersHeaderContainer}>
              <Typography variant={'h1'} className={classes.gridHeader}>
                {t('sessions:header.title')}
              </Typography>
            </div>
            <Pagination className={classes.adminPaginationFlex} pageInfo={pageInfo} getPage={getPages} />
          </div>
          <div
            className={[
              classes.adminTableContainerFlex,
              isSidebarMinimized ? classes.adminTableContainerFullWidth : classes.adminTableContainerNarrowed,
            ].join(' ')}
          >
            <SelectableTable<SessionsTableItem, SessionSortBy>
              columns={columns}
              rows={sessionsData}
              onFilterChange={handleFilterChange}
              filter={filter}
              filterElements={filterElements}
              isMultiChoice={false}
              closeFilterItem={uncheckFilterItem}
              uncheckAllFilters={uncheckAllFilters}
              filterbar={filterState}
              sortByProperty={sortByColumnId}
              isDescending={isDescending}
              setIsDescending={setIsDescending}
              setSortByColumn={setSortByColumnId}
              withHighFilterRow={false}
              onEnterMethod={onSessionActionsClick}
              caption={t('global:sidebar.sessions')}
            />
          </div>
        </div>
        <SessionDetailsModal
          sessionId={sessionId}
          reloadOnClose={() => getSessions()}
          onClose={() => history.push(Paths.sessions)}
        />
        <SessionsParametersDialog
          xCloseButton={handleXClose}
          onClose={closeModal}
          id="sessionsParametersDialog"
          open={isModalOpen}
          sheetId={modalSheetId}
          title={modalTitle}
          activeTab={modalActiveTab}
          isSheetConfigured={modalIsSheetConfigured}
        />
        <SessionsImagesDialog
          xCloseButton={() => handleXClose(false)}
          onClose={closeModal}
          id="sessionsImagesDialog"
          open={isModalImageOpen}
          sheetId={modalSheetId}
          title={modalTitle}
          sheetSymbol={activeSheetSymbol}
          isConfigured={modalIsSheetConfigured}
        />
        <SessionsCopyDialog
          id="sessionCopyDialog"
          sheetId={selectedExamSheetId}
          title="Kopiowanie arkusza"
          onClose={() => setIsSessionCopyDialogOpen(false)}
          open={isSessionCopyDialogOpen}
        />
        {isFinancialReportOpen && (
          <FinancialReport
            onCancel={() => setIsFinancialReportOpen(false)}
            onSave={() => setIsFinancialReportOpen(false)}
            sheetCode={selectedSheetCode}
            sheetId={selectedSessionId}
          />
        )}
        {isExamResultsRepositoryOpen && (
          <ExamResultsRepository
            sourceSystem={selectedSoureSystem}
            sheetCode={selectedSheetCode}
            examSheetId={selectedSheetId}
            onClose={() => setIsExamResultsRepositoryOpen(false)}
            type={examRepositoryModalType}
          />
        )}
        {isLeavePromptOpen && (
          <LeavePrompt isOpen={true} onConfirm={closeModal} onCancel={() => setIsLeavePromptOpen(false)} />
        )}
        {isImportExamineeModalApi && (
          <ImportExamineeListApi
            isOpen={isImportExamineeModalApi}
            handleClose={() => {
              setIsImportExamineeModalApi(false);
            }}
            modalTitle={modalTitle}
            statistic={examineeCount}
            sheetId={modalSheetId}
            importFromFile={isImportFromFile}
            system={selectedSystem}
          />
        )}
        {isAdjustmentsModalOpen && (
          <AdjustmentsModal
            onClose={closeModal}
            title={modalTitle}
            examSheetId={modalSheetId}
            isConfigured={modalIsSheetConfigured}
            importedFromExternalSystem={modalIsSheetImported}
            selectedSystem={selectedSystem}
          />
        )}
        <Prompt
          type="confirmation"
          open={isConfirmationPromptVisible}
          mainText={'Czy na pewno chcesz usunąć Sesję Egzaminacyjną?'}
          mainActionButtonText="TAK"
          onConfirm={deleteExaminigSession}
          onCancel={() => setIsConfirmationPromptVisible(false)}
        />
        <Prompt
          type="error"
          open={isErrorPromptVisible}
          mainText={'Usunięcie danych sesji egzaminacyjnej nie powiodło się.'}
          subTexts={[{ text: 'Spróbuj ponownie później.' }]}
          onConfirm={() => setIsErrorPromptVisible(false)}
        />
        <Prompt
          type="success"
          open={isSuccessPromptVisible}
          mainText={'Usunięcie danych sesji egzaminacyjnej zakończone sukcesem'}
          mainActionButtonText="POWRÓT DO LISTY"
          onConfirm={() => setIsSuccessPromptVisible(false)}
        />
        <Prompt
          type="confirmation"
          open={isResultsExportConfirmationPromptVisible}
          mainText={'Czy na pewno chcesz przesłać wyniki wybranej sesji do SIOEPKZ?'}
          mainActionButtonText="TAK"
          onConfirm={exportExaminigSessionResults}
          onCancel={() => setIsResultsExportConfirmationPromptVisible(false)}
        />
        <Prompt
          type="confirmation"
          open={isDeletePromptVisible}
          mainText={`Czy na pewno chcesz usunąć arkusz egzaminacyjny: ${selectedSheetCode}`}
          mainActionButtonText="TAK"
          onConfirm={deleteClosed}
          onCancel={() => setIsDeletePromptVisible(false)}
        />
        {examinerTreemapModalOpen && selectedSession && (
          <ExaminerTreemapModal data={selectedSession} onClose={() => setExaminerTreemapModalOpen(false)} />
        )}
      </div>
    </Layout>
  );
};

export default Sessions;
